import {Injectable, inject} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {LocalStorageService} from './local-storage.service';

@Injectable({providedIn: 'root'})
export class ThemeService {

    private localStorage = inject(LocalStorageService);
    private readonly isDarkModeSubject = new BehaviorSubject<boolean>(false);
    readonly isDarkMode$ = this.isDarkModeSubject.asObservable();

    constructor() {
        const saved = this.localStorage.getItem('theme');
        const isDark = saved === 'dark';
        this.isDarkModeSubject.next(isDark);
        this.applyTheme(isDark);
    }

    get isDarkMode(): boolean {
        return this.isDarkModeSubject.value;
    }

    toggleTheme(): void {
        const next = !this.isDarkModeSubject.value;
        this.isDarkModeSubject.next(next);
        this.localStorage.setItem('theme', next ? 'dark' : 'light');
        this.applyTheme(next);
    }

    private applyTheme(isDark: boolean): void {
        document.documentElement.setAttribute('data-bs-theme', isDark ? 'dark' : 'light');
    }
}
